import React from 'react'
import { Outlet } from 'react-router-dom'

import { Box, Button, Tabs } from '@factorialco/deprecated-design-system'
import { GetAllBudgetsCountDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { checkFeatures } from 'modules/core/hooks/useFeatures'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { BudgetsDataCollection } from 'modules/finance/components/Budgets/BudgetsDataCollection'
import { BudgetList } from 'modules/finance/components/Budgets/List'
import BudgetsLanding from 'modules/finance/components/Budgets/List/BudgetsLanding'
import { events } from 'modules/finance/lib/events'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const TABS = {
  active: 'active',
  archive: 'archive',
}

const BudgetListPage = () => {
  const { navigation } = useNavigation()
  const [tab, setTab] = React.useState(TABS.active)
  const { company } = useCurrentSession()

  const { data, error, loading } = useQuery(GetAllBudgetsCountDocument, {
    variables: {
      companyId: company.id,
    },
  })

  const { has_dev_training_budgets } = checkFeatures(
    ['dev_training_budgets'],
    data?.features.featuresConnection.nodes
  )

  const totalBudgets = data?.finance.budgetsConnection.totalCount ?? 0

  const canSeeBudgets = data?.finance._policies.budgetsSeeBudgets.can ?? false
  const canCreateBudgets = data?.finance._policies.budgetsCreateBudgets.can ?? false
  const canManageBudgets = data?.finance._policies.budgetsManageBudgets.can ?? false

  return (
    <ResponsivePage.Body variant="full" loading={loading} error={error} authorized={canSeeBudgets}>
      {totalBudgets === 0 && <BudgetsLanding />}
      {totalBudgets > 0 && (
        <>
          {canCreateBudgets && !has_dev_training_budgets && (
            <Box alignItems="flexEnd">
              <Button.Router
                iconName="add"
                to={navigation.expenses.budgets.list.new.fullPath()}
                onClick={() => {
                  track(events.clickAddBudget)
                }}
              >
                {i18n.t('budgets.navbar.add_budget')}
              </Button.Router>
            </Box>
          )}
          {!has_dev_training_budgets && (
            <Tabs currentId={tab} onTabClicked={setTab}>
              <Tabs.Tab id={TABS.active} label={i18n.t('budgets.list.tabs.active')}>
                <Box paddingTop="s24">
                  <BudgetList canManageBudgets={canManageBudgets} />
                </Box>
              </Tabs.Tab>
              <Tabs.Tab id={TABS.archive} label={i18n.t('budgets.list.tabs.archive')}>
                <Box paddingTop="s24">
                  <BudgetList canManageBudgets={canManageBudgets} archived />
                </Box>
              </Tabs.Tab>
            </Tabs>
          )}
        </>
      )}
      {has_dev_training_budgets && (
        <Box paddingTop="s24">
          <BudgetsDataCollection
            canManageBudgets={canManageBudgets}
            canCreateBudgets={canCreateBudgets}
          />
        </Box>
      )}
      <Outlet />
    </ResponsivePage.Body>
  )
}
export default BudgetListPage
